import ConversationContainer from './conversation-container';

export default ConversationContainer;
